module.exports = __webpack_public_path__ + "static/img/torso12.56750aa4.jpg";